<header class="cabecera">
  <div class="cabecera-in">
    <h1>Contactos</h1>
    <p>Tu agenda de nombres y teléfonos, siempre a mano.</p>
  </div>
</header>

<main class="contenedor">
  <section class="panel panel-lista" aria-labelledby="titulo-lista">
    <div class="lista-cab">
      <h2 id="titulo-lista" tabindex="-1">
        Tus contactos
        @if (!cargando() && !errorCarga()) {
          <span class="contador" data-testid="contador">{{ registros().length }}</span>
        }
      </h2>
      <button type="button" class="nuevo-movil" (click)="nuevoContacto()">+ Nuevo</button>
    </div>

    <!-- Copia solo visual: el anuncio accesible ya lo hace la región de estado del formulario. -->
    <div class="resultado-region" aria-hidden="true" data-testid="resultado-lista">
      @if (resultado(); as r) {
        @if (r.enLista && r.tipo === 'ok') {
          <p class="aviso"><span class="icono">✓</span> {{ r.texto }}</p>
        }
      }
    </div>

    @if (cargando()) {
      <p role="status">Cargando contactos…</p>
    } @else if (errorCarga()) {
      <p class="alerta" role="alert">{{ errorCarga() }}</p>
      <button type="button" (click)="cargar()">Reintentar</button>
    } @else if (registros().length === 0) {
      <p class="vacio">Todavía no hay contactos. Añade el primero con el formulario.</p>
    } @else {
      <div class="buscador">
        <label for="busqueda" class="sr-only">Buscar contacto por nombre o teléfono</label>
        <input id="busqueda" type="search" autocomplete="off" enterkeyhint="search"
               placeholder="Buscar por nombre o teléfono" [value]="busqueda()"
               (input)="actualizarBusqueda($any($event.target).value)">
        <p class="estado-busqueda" role="status" aria-live="polite" data-testid="estado-busqueda">
          @if (filtrando()) {
            {{ visibles().length }} de {{ registros().length }} contactos
          }
        </p>
      </div>

      @if (visibles().length === 0) {
        <div class="sin-resultados" data-testid="sin-resultados">
          <p>Ningún contacto coincide con «{{ busqueda().trim() }}».</p>
          <button type="button" (click)="limpiarBusqueda()">Borrar búsqueda</button>
        </div>
      } @else {
        <ul class="lista">
          @for (r of visibles(); track r.id; let i = $index) {
            <!-- Cabecera de letra (decorativa): agrupa el listado alfabético como una agenda. -->
            @if (i === 0 || visibles()[i - 1].nombre.trim().normalize('NFD').charAt(0).toUpperCase() !== r.nombre.trim().normalize('NFD').charAt(0).toUpperCase()) {
              <li class="letra" aria-hidden="true" data-testid="letra">{{ r.nombre.trim().normalize('NFD').charAt(0).toUpperCase() || '#' }}</li>
            }
            <li class="fila" data-testid="registro" [class.seleccionada]="editando()?.id === r.id"
                [attr.aria-current]="editando()?.id === r.id ? 'true' : null">
              <div class="avatar" aria-hidden="true">{{ (r.nombre.trim().charAt(0) || '?').toUpperCase() }}</div>
              <div class="datos">
                <span class="nombre">{{ r.nombre }}</span>
                @if (telefonoEnlace(r); as href) {
                  <a class="telefono" [attr.href]="href" [attr.aria-label]="'Llamar a ' + r.nombre + ': ' + r.telefono">{{ r.telefono }}</a>
                } @else {
                  <span class="telefono">{{ r.telefono }}</span>
                }
                @if (editando()?.id === r.id) { <span class="insignia">En edición</span> }
              </div>
              <div class="acciones">
                <button type="button" [id]="'editar-' + r.id" (click)="editar(r)" [attr.aria-label]="'Editar contacto ' + r.nombre">Editar</button>
                <button type="button" [id]="'eliminar-' + r.id" class="peligro-suave"
                        (click)="pedirBorrado(r, $any($event.currentTarget))" [attr.aria-label]="'Eliminar contacto ' + r.nombre">Eliminar</button>
              </div>
            </li>
          }
        </ul>
      }
    }
  </section>

  <section class="panel panel-form" [class.editando]="editando()" aria-labelledby="titulo-form">
    <h2 id="titulo-form">{{ editando() ? 'Editar contacto' : 'Nuevo contacto' }}</h2>

    @if (editando(); as ed) {
      <p class="contexto" data-testid="contexto-edicion">
        <span class="etiqueta">Estás editando a</span>
        <strong class="contexto-nombre">{{ ed.nombre }}</strong>
        <span class="contexto-tel">{{ ed.telefono }}</span>
      </p>
    }

    @if (sucio()) {
      <p class="sin-guardar" data-testid="sin-guardar">Cambios sin guardar</p>
    }

    <div class="resultado-region" role="status" aria-live="polite" aria-atomic="true" data-testid="resultado">
      @if (resultado(); as r) {
        @if (r.tipo === 'ok') {
          <p class="aviso"><span class="icono" aria-hidden="true">✓</span> {{ r.texto }}</p>
        }
      }
    </div>
    <div class="resultado-region" role="alert" data-testid="resultado-error">
      @if (resultado(); as r) {
        @if (r.tipo === 'error') {
          <p class="alerta"><span class="icono" aria-hidden="true">!</span> {{ r.texto }}</p>
        }
      }
    </div>

    <form [formGroup]="form" (ngSubmit)="guardar()" novalidate>
      <div class="campo">
        <label for="nombre">Nombre del contacto</label>
        <input id="nombre" type="text" formControlName="nombre" autocomplete="name" autocapitalize="words"
               enterkeyhint="next"
               [attr.maxlength]="nombreMax + 50" aria-describedby="ayuda-nombre error-nombre"
               [attr.aria-invalid]="mostrar('nombre') || !!erroresServidor()['nombre']">
        <div id="ayuda-nombre" class="ayuda">Hasta {{ nombreMax }} caracteres.</div>
        <div id="error-nombre" class="error" aria-live="polite">
          @if (mostrar('nombre') && form.controls.nombre.errors; as e) {
            @if (e['required'] || e['vacio']) { El nombre es obligatorio. }
            @else if (e['maxlength']) { El nombre admite como máximo {{ nombreMax }} caracteres. }
          }
          @if (erroresServidor()['nombre']; as s) { {{ s }} }
        </div>
      </div>

      <div class="campo">
        <label for="telefono">Teléfono</label>
        <input id="telefono" type="text" inputmode="tel" formControlName="telefono" autocomplete="tel"
               enterkeyhint="done"
               [attr.maxlength]="telefonoMax + 20" aria-describedby="ayuda-telefono error-telefono"
               [attr.aria-invalid]="mostrar('telefono') || !!erroresServidor()['telefono']">
        <div id="ayuda-telefono" class="ayuda">
          Puedes incluir prefijo internacional (+34), espacios y ceros iniciales. Máximo {{ telefonoMax }} caracteres.
        </div>
        <div id="error-telefono" class="error" aria-live="polite">
          @if (mostrar('telefono') && form.controls.telefono.errors; as e) {
            @if (e['required'] || e['vacio']) { El teléfono es obligatorio. }
            @else if (e['maxlength']) { El teléfono admite como máximo {{ telefonoMax }} caracteres. }
          }
          @if (erroresServidor()['telefono']; as s) { {{ s }} }
        </div>
      </div>

      <div class="acciones acciones-form">
        <button type="submit" class="primario" [disabled]="guardando()">
          {{ guardando() ? 'Guardando…' : (editando() ? 'Guardar cambios' : 'Añadir contacto') }}
        </button>
        @if (editando()) {
          <button type="button" (click)="cancelarEdicion()" [disabled]="guardando()">Cancelar edición</button>
        }
      </div>
    </form>
  </section>
</main>

@for (r of registros(); track r.id) {
  @if (confirmandoId() === r.id) {
    <div class="telon" (click)="cancelarBorrado()">
      <div #dialogo class="dialogo" role="alertdialog" aria-modal="true"
           aria-labelledby="dialogo-titulo" aria-describedby="dialogo-desc"
           (click)="$event.stopPropagation()" (keydown)="teclaDialogo($event, dialogo)">
        <h2 id="dialogo-titulo">¿Eliminar contacto?</h2>
        <p id="dialogo-desc">
          Se eliminará a <strong>{{ r.nombre }}</strong> ({{ r.telefono }}). Esta acción no se puede deshacer.
        </p>
        @if (errorBorrado(); as msg) {
          <p class="alerta" role="alert">{{ msg }}</p>
        }
        <div class="acciones acciones-dialogo">
          <button type="button" id="cancelar-borrado" (click)="cancelarBorrado()" [disabled]="borrandoId() === r.id">Cancelar</button>
          <button type="button" id="confirmar-borrado" class="peligro" (click)="confirmarBorrado(r)" [disabled]="borrandoId() === r.id">
            {{ borrandoId() === r.id ? 'Eliminando…' : 'Sí, eliminar' }}
          </button>
        </div>
      </div>
    </div>
  }
}

@if (pendiente(); as p) {
  <div class="telon" data-testid="telon-descarte" (click)="seguirEditando()">
    <div #aviso class="dialogo" role="alertdialog" aria-modal="true" data-testid="dialogo-descarte"
         aria-labelledby="descarte-titulo" aria-describedby="descarte-desc"
         (click)="$event.stopPropagation()" (keydown)="teclaDescarte($event, aviso)">
      <h2 id="descarte-titulo">¿Descartar los cambios sin guardar?</h2>
      <p id="descarte-desc">
        @if (editando(); as ed) {
          Has modificado el formulario de <strong>{{ ed.nombre }}</strong>.
        } @else {
          Has escrito datos de un contacto nuevo que aún no se han guardado.
        }
        @switch (p.tipo) {
          @case ('nuevo') { Si empiezas un contacto nuevo, se perderán. }
          @case ('editar') { Si pasas a editar a <strong>{{ p.registro.nombre }}</strong>, se perderán. }
          @case ('cancelar') { Si cancelas la edición, se perderán. }
        }
      </p>
      <div class="acciones acciones-dialogo">
        <button type="button" id="descartar-cambios" class="peligro" (click)="descartarCambios()">Descartar cambios</button>
        <button type="button" id="seguir-editando" class="primario" (click)="seguirEditando()">Seguir editando</button>
      </div>
    </div>
  </div>
}
